import Spin from '@/components/Spin';
import { handleSubmitError } from '@/helpers/errorHandle';
import { apiSdk } from '@/httpClient';
import { faEdit, faSave } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type Props = {
  bookingId: string;
  agentBookingRef?: string;
  onBookingRefChange: (newRef: any) => void;
};

export default function AgentBookingRef({ agentBookingRef, bookingId, onBookingRefChange }: Props) {
  const [loading, setLoading] = React.useState(false);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const ref = React.useRef<HTMLInputElement>();
  React.useEffect(() => {
    if (isEditMode) {
      ref.current?.focus();
    }
  }, [isEditMode]);
  const onSave = () => {
    let value = ref.current?.value;
    setLoading(true);
    apiSdk.AgentBookingService.updateAgentBookingRef({ body: { bookingId: bookingId, agentBookingRef: value } })
      .then(res => {
        if (res.success) {
          setIsEditMode(false);
          onBookingRefChange(value);
        } else {
          handleSubmitError(res);
        }
      })
      .catch(handleSubmitError)
      .finally(() => setLoading(false));
  };
  return (
    <Spin loading={loading}>
      <div className="text-dark-2">Agent Booking Reference</div>
      {isEditMode ? (
        <div className="position-relative border-blue-1 rounded pl-10 pr-40">
          <input style={{ lineHeight: '44px', height: 44 }} ref={ref as any} defaultValue={agentBookingRef} />
          <button
            onClick={onSave}
            className="position-absolute  rounded-100 bg-green-2"
            style={{ width: 30, height: 30, top: 8, right: 5, lineHeight: '30px', textAlign: 'center' }}
          >
            <FontAwesomeIcon icon={faCheck} className="text-white text-14" />
          </button>
        </div>
      ) : (
        <div className="fw-500 bg-light-2 rounded p-2 position-relative" style={{ minHeight: 46 }}>
          {agentBookingRef}
          <button
            onClick={() => setIsEditMode(true)}
            className="position-absolute  rounded-100 bg-blue-1"
            style={{ width: 30, height: 30, top: 8, right: 5, lineHeight: '30px', textAlign: 'center' }}
          >
            <FontAwesomeIcon icon={faEdit} className="text-white text-14" />
          </button>
        </div>
      )}
    </Spin>
  );
}
